module.exports = __webpack_public_path__ + "static/media/vivi-andando-3.da817408.svg";